import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import {
  ChannelAccessibleChannelIndexResponse,
  channelApiClient,
} from '@src/api/shared/community/channelApiClient';
import { useEffect, useState } from 'react';

export const useAccessibleChannels = (isLogin: boolean | undefined) => {
  const [accessibleChannels, setAccessibleChannels] =
    useState<ChannelAccessibleChannelIndexResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAccessibleChannels = async () => {
      if (isLogin === undefined) {
        // Don't set loading to false yet, wait for isLogin to be determined
        return;
      }

      if (!isLogin) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      const res = await channelApiClient.accessibleChannelIndex();
      handleApiResponse(res, (data) => {
        setAccessibleChannels({
          channel: data.channel,
        });
        setIsLoading(false);
      });
    };

    fetchAccessibleChannels();
  }, [isLogin]);

  return { accessibleChannels, isLoading };
};
